package songwritersnotebook.app.utils

import androidx.compose.runtime.Composable
import kotlinx.browser.window

actual class PlatformUtils actual constructor() {
    actual fun openUrl(url: String) {
        println("DEBUG_PLATFORM: openUrl called with $url")
        if (url.startsWith("/")) {
            window.location.href = url
        } else {
            window.open(url, "_blank")
        }
    }

    actual fun shareText(text: String) {
        val nav = window.navigator.asDynamic()
        if (nav.share != null) {
            nav.share(js("{text: text}"))
        } else {
            copyToClipboard(text)
        }
    }

    actual fun copyToClipboard(text: String) {
        window.navigator.clipboard.writeText(text)
    }

    actual fun sendEmail(to: String, subject: String, body: String) {
        val mailto = "mailto:$to?subject=${SnBridge.encodeURIComponent(subject)}&body=${SnBridge.encodeURIComponent(body)}"
        window.open(mailto)
    }

    actual fun getInitialRoute(): String? {
        return window.location.pathname
    }

    actual fun getWebBrowserOS(): String? {
        val ua = window.navigator.userAgent
        if (ua.contains("Android")) return "Android"
        if (ua.contains("iPhone") || ua.contains("iPad")) return "iOS"
        return null
    }
}

@Composable
actual fun getPlatformContext(): Any = Any()

actual fun setupAppLifecycleObserver(onWake: () -> Unit) {
    kotlinx.browser.window.document.addEventListener("visibilitychange", {
        if (kotlinx.browser.window.document.asDynamic().visibilityState == "visible") {
            onWake()
        }
    })
}
